module.exports = __webpack_public_path__ + "img/liuzhou.c3669e8b.png";